<template>
    <div class="col-12">
        <div class="card card-blue">
            <div class="card-header">
                <h4 class="card-title">Challan</h4>
                <h5 class="card-subtitle">Available challans</h5>
            </div>

            <div class="card-body">
                <div class="table-responsive">
                    <div class="col-md-12">
                        <div class="form-group row">
                            <div class="col-4">
                                <multiselect :clear-on-select="false"
                                             :close-on-select="true"
                                             :hide-selected="true"
                                             :internal-search="false"
                                             :options="partners"
                                             :searchable="true"
                                             :show-no-results="false"
                                             @search-change="searchPartners"
                                             class="form-control multiselect-sm"
                                             data-vv-as="Buyer"
                                             label="buyer"
                                             name="buyer"
                                             open-direction="bottom"
                                             placeholder="Search Buyer"
                                             track-by="id"
                                             v-model="partner"
                                             v-validate="'required'">
                                    <template slot="singleLabel" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc">
                                                {{ props.option.org_name }}
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc" v-if="props.option">
                                                <h5>{{ props.option.org_name }}</h5>
                                            </div>
                                            <div class="option__desc" v-else>
                                                <h5>Add New</h5>
                                            </div>
                                        </div>
                                    </template>
                                </multiselect>
                            </div>
                            <div class="col-4">
                                <multiselect
                                        :clear-on-select="false"
                                        :close-on-select="true"
                                        :hide-selected="true"
                                        :internal-search="false"
                                        :options="warehouses"
                                        :searchable="true"
                                        :selectLabel="''"
                                        :show-no-results="false"
                                        @search-change="searchWarehouses"
                                        class="form-control multiselect-sm"
                                        id="warehouse"
                                        label="Search Warehouse"
                                        name="customer"
                                        open-direction="bottom"
                                        placeholder="Search Warehouses"
                                        v-model="warehouse">
                                    <template slot="singleLabel" slot-scope="props">
                                        {{props.option.name}}
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <h5>{{ props.option.name }}</h5>
                                            <div>{{ props.option.description }}</div>
                                        </div>
                                    </template>
                                    <span slot="noResult">Purchaser not found</span>
                                </multiselect>
                            </div>
                            <div class="col-2">
                                <multiselect :options="['DRAFT','CONFIRMED','INVOICED']"
                                             class="form-control multiselect-sm"
                                             placeholder="Select Status"
                                             v-model="status">
                                </multiselect>
                            </div>
                            <div class="col-2">
                                <input class="form-control" placeholder="Challan No" type="text" v-model="number">
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-4">
                                <multiselect :clear-on-select="false"
                                             :close-on-select="true"
                                             :hide-selected="true"
                                             :internal-search="false"
                                             :limit="3"
                                             :max-height="600"
                                             :options="goods"
                                             :options-limit="300"
                                             :searchable="true"
                                             :show-no-results="false"
                                             @search-change="searchGoods"
                                             class="form-control multiselect-sm"
                                             data-vv-as="Good"
                                             id="goodsservice"
                                             label="goodsservice"
                                             name="goodsservice"
                                             open-direction="bottom"
                                             placeholder="Search Goods/Service"
                                             selectLabel=""
                                             track-by="id"
                                             v-model="good"
                                             v-validate="'required'">
                                    <template slot="singleLabel" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc"
                                                 style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                                                {{ props.option.commodity_name }} - {{ props.option.variety }}
                                            </div>
                                        </div>
                                    </template>
                                    <template slot="option" slot-scope="props">
                                        <div class="option__desc">
                                            <div class="option__desc" v-if="props.option">
                                                <h5>{{ props.option.commodity_name }}</h5>
                                                {{ props.option.variety}}
                                            </div>
                                        </div>
                                    </template>
                                </multiselect>
                            </div>

                            <div class="col-2">
                                <input class="form-control" id="startdate" placeholder="Start Date" type="text"/>
                            </div>

                            <div class="col-2">
                                <input class="form-control" id="enddate" placeholder="End Date" type="text"/>
                            </div>

                            <div class="col-2">
                                <div class="btn-group" style="display: flex;">
                                    <button @click="getChallans(1)"
                                            class="btn btn-light btn-outline-success font-weight-bold" style="flex: 1"
                                            type="button">
                                        <i class="fa fa-search"/> Go!
                                    </button>
                                    <button @click="reset()"
                                            class="btn btn-light btn-outline-secondary btn-arrange font-weight-bold"
                                            style="flex: 1" type="button">
                                        <i class="fa fa-undo"/> Reset
                                    </button>
                                </div>
                            </div>

                            <div class="col-2 text-right">
                                <span class="fa-xs fa-stack fa-1x ml-auto text-muted" title="Exporting, please wait ..."
                                      v-if="exporting">
                                          <i class="fa fa-circle-notch fa-stack-2x fa-spin"></i>
                                          <i class="fa fa-xs fa-file-excel fa-stack-1x"></i>
                                        </span>
                                <button aria-expanded="false" aria-haspopup="true"
                                        class="btn waves-effect waves-light btn-outline-info"
                                        data-toggle="dropdown" title="Operations">
                                    <i class="fa fa-grip-vertical"/>
                                </button>
                                <div class="dropdown-menu">
                                    <a @click="exportChallansAsExcel()" class="dropdown-item" href="javascript:void(0)">
                                        <i class="fa fa-file-excel"/> Export Challans
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <table class="table no-wrap v-top" v-if="challans.length >0">
                        <thead>
                        <tr class="border-0 bg-light">
                            <th class="border-0"><h6>Challan No</h6></th>
                            <th class="border-0"><h6>Buyer</h6></th>
                            <th class="border-0"><h6>Reference</h6></th>
                            <th class="border-0 text-center"><h6>Status</h6></th>
                            <th class="border-0 text-right"><h6>Total</h6></th>
                            <th class="border-0"><h6>Timestamp</h6></th>
                            <th class="border-0 text-center"><h6>Action</h6></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-bind:key="index" v-for="(c, index) in challans">
                            <td>{{c.number}}</td>
                            <td>{{c.buyer}}</td>
                            <td>{{c.reference}}</td>
                            <td class="text-center">
                                <span :class="{
                                            'label-info' : c.status === 'DRAFT' ,
                                            'label-success' : c.status === 'CONFIRMED' ,
                                            'label-inverse' : c.status === 'INVOICED'
                                            }"
                                      class="label font-weight-bold">
                                    <template v-if="c.status === 'DRAFT'">Draft</template>
                                    <template v-if="c.status === 'CONFIRMED'">Confirmed</template>
                                    <template v-if="c.status === 'INVOICED'">Invoiced</template>
                                </span>
                            </td>
                            <td class="text-right">{{currentOrg.currency_symbol}} {{c.total | unitFix(2)}}</td>
                            <td>{{c.created_at | timestamp}}</td>
                            <td class="text-center">
                                <h6>
                                    <router-link :to="{name: 'marketplaceviewchallan', params : { challanid: c.id}}" class="ml-3"
                                                 title="Details">
                                        <i class="fa fa-eye"/>
                                    </router-link>
                                    <router-link :to="{name: 'marketplaceeditchallan', params : { challanid: c.id}}" class="text-info ml-3" title="Edit"
                                                 v-if="c.status === 'DRAFT'">
                                        <i class="fa fa-edit"/>
                                    </router-link>
                                    <a @click="challan = c" class="text-danger ml-3" data-target="#deleteModal"
                                       data-toggle="modal" href="javascript:void(0)" title="Delete"
                                       v-if="c.status === 'DRAFT'">
                                        <i class="fa fa-trash-alt"/>
                                    </a>
                                </h6>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <template v-else>
                        <h4 class="card-title text-muted text-center m-t-30">No records found.</h4>
                        <h5 class="card-title text-muted text-center m-b-30">Change search criteria and try again</h5>
                    </template>
                </div>
            </div>

            <div class="card-footer" v-if="challans.length>0">
                <div class="row">
                    <div class="col-6">
                        <div class="row">
                            <label class="col-form-label p-l-10">Display</label>
                            <div class="col-auto p-t-5">
                                <select @change="perPageRecordChange()" aria-controls="lang_opt"
                                        class="form-control form-control-sm" name="lang_opt_length"
                                        v-model="perPage">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                            <label class="col-form-label">Records per page</label>
                        </div>
                    </div>

                    <div class="col-6">
                        <paginate
                                :click-handler="pageHandler"
                                :container-class="'pagination float-right mb-0'"
                                :margin-pages="2"
                                :next-class="'page-link'"
                                :next-text="'Next'"
                                :page-class="'page-link'"
                                :page-count=pageCount
                                :page-range="3"
                                :prev-class="'page-link'"
                                :prev-text="'Prev'">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="deleteModal" role="dialog" tabindex="-1">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="card card-blue mb-0">
                        <div class="card-body pt-5">
                            <p class="text-center"><i class="fa fa-5x fa-exclamation-triangle text-warning"/></p>
                            <h5 class="my-5">You are about to delete challan <b class="text-info">{{challan.number}}</b>.
                                Are you sure?</h5>
                            <button @click="deleteChallan" class="btn btn-success float-left" type="button">
                                Yes
                            </button>
                            <button aria-label="Close" class="btn btn-secondary float-right" data-dismiss="modal"
                                    type="button">
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import Paginate from "vuejs-paginate";
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import XLSX from "xlsx";

    export default {
        name: "List",
        components: {Multiselect, Paginate},
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                partners: [],
                goods: [],
                challans: [],
                pageCount: 1,
                total: 0,
                perPage: 10,
                date: null,
                status: null,
                number: null,
                warehouses: [],
                warehouse: null,
                exporting: false,
                challan: {},
                startdate: null,
                enddate: null,
                partner: null,
                good: null
            }
        },
        mounted() {
            let self = this;

            $(function () {
                $('#startdate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.startdate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.startdate = null;
                        }
                    });

                $('#enddate')
                    .datepicker({
                        format: "dd/mm/yyyy",
                        autoclose: true
                    })
                    .on('changeDate', (e) => {
                        let parts = e.target.value.split('/');
                        if (parts.length > 0) {
                            self.enddate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                        } else {
                            self.enddate = null;
                        }
                    });
            });

            this.init();
        },
        methods: {
            async init() {
                await this.getChallans(1);
            },
            async getChallans(page) {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/challans`, {
                        params: {
                            page: page,
                            perPage: this.perPage,
                            status: this.status,
                            number: this.number,
                            start: this.startdate,
                            end: this.enddate,
                            buyerid: this.partner ? this.partner.org_id : undefined,
                            warehouseid: this.warehouse ? this.warehouse.id : undefined,
                            goodid: this.good ? this.good.commodity_id : undefined
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total = data.total;
                    this.challans = data.challans;
                    this.setPageCount();
                } catch (e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getChallans(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            perPageRecordChange() {
                if (this.isFiltered) {
                    this.getChallans(1);
                } else {
                    this.getChallans(1);
                }
            },
            async searchWarehouses(search) {
                let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/search`, {
                    params: {
                        search: search
                    }
                });
                this.warehouses = data;
            },
            async reset() {
                $('#startdate, #enddate').datepicker('setDate', null);
                this.status = null;
                this.number = null;
                this.warehouse = null;
                this.startdate = null;
                this.enddate = null;
                this.partner = null;
                this.good = null;
                await this.getChallans()
            },
            async deleteChallan() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/challans/${this.challan.id}`);
                    this.$toastr('success', 'Challan deleted', 'Success');
                    await this.init();
                } catch (e) {
                    this.$toastr('error', 'Challan deletion failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                    $("#deleteModal").modal('hide');
                }
            },
            async searchPartners(searchText) {
                try {
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = reply.data;
                } catch (e) {
                    console.log(e);
                }
            },
            async searchGoods(search) {
                let reply = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/commodities/search`, {
                    params: {
                        search,
                        excludeOld: true
                    }
                });
                this.goods = reply.data;
            },
            async exportChallansAsExcel() {
                try {
                    this.exporting = true;
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/challans`, {
                        params: {
                            page: 1,
                            perPage: this.total,
                            status: this.status,
                            number: this.number,
                            start: this.startdate,
                            end: this.enddate,
                            buyerid: this.partner ? this.partner.org_id : undefined,
                            warehouseid: this.warehouse ? this.warehouse.id : undefined,
                            goodid: this.good ? this.good.commodity_id : undefined
                        }
                    });

                    let challans = [];
                    let challanids = [];
                    let transactions = [];

                    data.challans.forEach(d => {
                        challans.push({
                            "Number": d.number,
                            "Buyer": d.buyer,
                            "Total": Number(d.total).toFixed(2),
                            "Status": d.status,
                            "Reference": d.reference,
                            "Timestamp": d.created_at
                        });
                        challanids.push(d.id);
                    });

                    // let reply = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/challans/transactions`, challanids);
                    //
                    // reply.data.forEach(d => {
                    //     transactions.push({
                    //         "Challan Number": d.number,
                    //         "Good": d.name,
                    //         "Variety": d.variety,
                    //         "Quantity": Number(d.quantity).toFixed(2) * -1,
                    //         "Unit": d.symbol
                    //     });
                    // });

                    let workbook = XLSX.utils.book_new();
                    let challansheet = XLSX.utils.json_to_sheet(challans);
                    XLSX.utils.book_append_sheet(workbook, challansheet, 'Challans');
                    let transactionsheet = XLSX.utils.json_to_sheet(transactions);
                    XLSX.utils.book_append_sheet(workbook, transactionsheet, 'Transactions');
                    XLSX.writeFile(workbook, 'Challans.xlsx');
                } catch (e) {
                    console.error(e)
                    this.$toastr('error', 'Export failed', 'Failure');
                } finally {
                    this.exporting = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
